"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Box_1 = __importDefault(require("@mui/system/Box"));
var Preact = __importStar(require("preact"));
var Tab_1 = __importDefault(require("@mui/material/Tab"));
var material_1 = require("@mui/material");
var themes_1 = require("./themes");
var TabSwatches = __importStar(require("./swatchesWithButtonScroll"));
var getActiveSwatchIndex = function (swatches) {
    var activeSwatch = swatches.find(function (swatch) { return swatch.active === true; });
    if (activeSwatch) {
        return swatches.indexOf(activeSwatch);
    }
    else {
        return 0;
    }
};
var Component = function (p) {
    var classes = (0, themes_1.useTabStyles)();
    return (Preact.h(Box_1.default, { width: "100%", height: "100%", display: "grid", gridTemplateRows: "50px auto" },
        Preact.h(material_1.Tabs, { value: p.value, "aria-label": "global colour options", textColor: "secondary", indicatorColor: "secondary", variant: "scrollable", classes: {
                root: classes.root,
                scroller: classes.scroller,
                indicator: p.loading ? classes.indicatorLoading : undefined,
            } }, p.tabHeaders.map(function (header) { return (Preact.h(Tab_1.default, { label: header.label, value: header.propertyKey, disabled: p.loading, classes: {
                root: classes.removeTextTransform,
            }, onClick: function () { return p.onChangeTab(header.propertyKey); } })); })),
        p.loading ? (Preact.h(Box_1.default, { display: "flex", flexDirection: "column", justifyContent: "center", gap: "20px", paddingX: "25%" },
            Preact.h(material_1.LinearProgress, { color: "secondary" }),
            Preact.h(material_1.Typography, { variant: "body2", textAlign: "center" }, "Updating your furniture"))) : (p.tabHeaders.map(function (header) {
            return header.propertyKey === p.value && (Preact.h(TabSwatches.Component, { tabContents: p.tabContents[header.propertyKey], activeSwatchIndex: getActiveSwatchIndex(p.tabContents[header.propertyKey]), onSelectSwatch: function (n) { return p.onSelectSwatch(n); } }));
        }))));
};
exports.Component = Component;
